

// buzzwareTech imports
import type { IWorkspace } from "@buzzwaretech/types";

export const orderWorkspacesList = (workspaces: IWorkspace[]): IWorkspace[] =>
  workspaces.sort((a, b) => a.name.localeCompare(b.name));
